import type { SiteConfig } from '@/types'

/*
 * Links stay empty until a real destination exists. An empty link renders as a
 * clearly marked "soon" placeholder instead of pointing somewhere invented.
 */
export const siteConfig: SiteConfig = {
    name: 'Ocuvia',
    tagline: "See beyond the surface.",
    description: "Ocuvia is a local-first desktop research workspace for retinal image screening, visual analysis and explainable AI. Download the latest available build.",
    mission: "A local-first research workspace for retinal image analysis.",
    url: 'https://ocuvia.modulify.website',
    ogImage: 'https://ocuvia.modulify.website/api/og',
    links: {
        github: '',
        documentation: '',
        support: ''
    }
}

/*
 * Ocuvia's software license. Leave both empty until the license is chosen
 * and published; the license page then says so instead of guessing.
 */
export const softwareLicense = {
    name: '',
    url: ''
}

export const navigation = [
    { label: 'Overview', href: '/#overview' },
    { label: 'Features', href: '/#features' },
    { label: "How it Works", href: '/#how-it-works' },
    { label: 'Screenshots', href: '/#screenshots' },
    { label: 'Download', href: '/#download' }
]

export const researchDisclaimer = "Ocuvia is a research prototype and is not intended to replace professional medical evaluation or provide an authorized clinical diagnosis."
